import { render } from "./Bulletin.vue?vue&type=template&id=1fde5263&scoped=true"
import script from "./Bulletin.vue?vue&type=script&lang=js"
export * from "./Bulletin.vue?vue&type=script&lang=js"

import "./Bulletin.vue?vue&type=style&index=0&id=1fde5263&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fde5263"]])

export default __exports__